<template>
  <div class="container-fluid">
    <div class="loading m-t-4 m-b-4" v-if="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
    <div class="row p-t-4 recomendations">
      <h1 class="m-b-3">{{t('Search by regions')}}</h1>
    <div class="col-md-4 m-b-2 recomendation" v-for="recomendation in recomendations">
      <router-link :to="`/${language}/search?location=${recomendation.location_id}&startDate=${startDate}&endDate=${endDate}`">

      <Card>
        <div slot="image">
          <img :src="recomendation.image.data.thumbnail_path" :alt="recomendation.image.data.locale[language].name"/>

        </div>
        <div slot="title">
          {{recomendation.translations[language].name}}
        </div>
        <div slot="content">
          {{recomendation.translations[language].description}}
        </div>

      </Card>
      </router-link>
    </div>
  </div>
  </div>

</template>


<script>
import moment from 'moment-mini';
import { mapState, mapActions } from 'vuex';
import Card from '../Card';

export default {
  name: 'SearchLinks',
  components: {
    Card,
  },
  data() {
    return {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(2, 'w').format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapState({
      language: state => state.language,
      recomendations: state => state.searchRecomendations.data,
      loading: state => state.searchRecomendations.loading,
    }),
  },
  methods: {
    ...mapActions({
      getSearchRecomendations: 'searchRecomendations/get',
    }),
  },
  mounted() {
    this.getSearchRecomendations();
  },
};

</script>


<style lang="scss" scoped>
.loading {
  text-align: center;
  i {
    font-size: 48px;
  }
}
.recomendation {
  float: none;
  display: inline-block;
}
.recomendations {
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// SearchLinks.vue?7ddeda74